module.exports = __webpack_public_path__ + "img/logo_telexpress_w.1f3df165.svg";